module.exports = __webpack_public_path__ + "assets/order.a27a5ec1.svg";